var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterGrayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.95896 7.67535C6.32032 7.67535 8.15849 4.96425 8.15849 2.6134C8.15849 2.53636 8.15688 2.45967 8.15325 2.3834C8.51003 2.13231 8.82022 1.81899 9.06492 1.46224C8.73745 1.60383 8.38509 1.69928 8.01544 1.74229C8.39275 1.52211 8.68241 1.17358 8.81901 0.75818C8.46586 0.961961 8.0749 1.11017 7.65865 1.18999C7.3252 0.844202 6.85027 0.627899 6.32474 0.627899C5.31545 0.627899 4.49702 1.42467 4.49702 2.40688C4.49702 2.54653 4.51309 2.68225 4.54441 2.81253C3.02566 2.7382 1.67889 2.03022 0.777656 0.953741C0.620569 1.21659 0.530178 1.52211 0.530178 1.84791C0.530178 2.46519 0.852797 3.01007 1.34337 3.32884C1.04366 3.31985 0.762015 3.23966 0.515713 3.10626C0.515286 3.11368 0.515286 3.12114 0.515286 3.12894C0.515286 3.99068 1.14531 4.71 1.98141 4.87313C1.82796 4.91378 1.66642 4.93571 1.49967 4.93571C1.38196 4.93571 1.26745 4.92436 1.15614 4.90362C1.3888 5.61046 2.06339 6.12482 2.86333 6.13931C2.23776 6.61649 1.44987 6.90085 0.593669 6.90085C0.446201 6.90085 0.300765 6.89266 0.157715 6.87622C0.966525 7.3808 1.92679 7.67535 2.95896 7.67535Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterGrayIcon);
export default __webpack_public_path__ + "static/media/twitter-gray-icon.574436795ce3f7971bdc9c256752a1d5.svg";
export { ForwardRef as ReactComponent };